import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Box, Text } from 'rebass';
import { FaChevronRight } from 'react-icons/fa';
import { RxDragHandleDots2 } from 'react-icons/rx';

import { memberFullName, memberRowSubtitle, imageUrlFromAttrs, cropParamsFromAttrs } from '../helpers';
import { FT_COLORS } from '../theme';
import CroppedAvatar from './CroppedAvatar';

// A single relative row: drag handle · avatar · "First · what baby calls them" · chevron.
const MemberRow = ({ member, onOpen, dragHandle }) => (
  <Flex
    alignItems="center"
    bg="white"
    p={2}
    mb={2}
    sx={{
      border: '1px solid',
      borderColor: FT_COLORS.rowBorder,
      borderRadius: '12px',
      cursor: 'pointer',
    }}
    onClick={() => onOpen && onOpen(member)}
  >
    {dragHandle}
    <CroppedAvatar
      url={imageUrlFromAttrs(member.image)}
      name={memberFullName(member)}
      size={40}
      circular
      {...cropParamsFromAttrs(member.image)}
    />
    <Box ml={2} flex="1 1 auto" css="min-width: 0;">
      <Text
        fontFamily="Poppins"
        fontWeight={500}
        fontSize="15px"
        color="#0E0E0E"
        css="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
      >
        {memberFullName(member)}
        {memberRowSubtitle(member) && (
          <Text as="span" fontWeight={400} color="mutedText">
            {`  ·  ${memberRowSubtitle(member)}`}
          </Text>
        )}
      </Text>
      {member.invitePending && (
        <Text fontFamily="Poppins" fontSize="12px" color={FT_COLORS.successText} mt="2px">
          Invite pending
        </Text>
      )}
    </Box>
    <Box ml={2} color="lightText" css="flex: 0 0 auto;">
      <FaChevronRight size={14} />
    </Box>
  </Flex>
)

// Default drag handle (used by the sortable group).
export const DragHandle = () => (
  <Box
    mr={1}
    color="lightText"
    css="flex: 0 0 auto; cursor: grab; display: inline-flex;"
    aria-label="Drag to reorder"
  >
    <RxDragHandleDots2 size={18} />
  </Box>
);

MemberRow.propTypes = {
  member: PropTypes.shape({
    image: PropTypes.shape({}),
    invitePending: PropTypes.bool,
  }).isRequired,
  onOpen: PropTypes.func,
  dragHandle: PropTypes.node,
};

MemberRow.defaultProps = {
  onOpen: null,
  dragHandle: null,
};

export default MemberRow;
